import clsx from 'clsx'

import { SPACING_CLASS_NAME } from './const'
import { SectionWrapperProps } from './type'

export const SectionWrapper = ({ children, spacing }: SectionWrapperProps) => {
  return <div className={clsx(SPACING_CLASS_NAME({ spacing }))}>{children}</div>
}
